import { useState, useEffect } from 'react';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

function getAspectRatio() {
    const { innerWidth: width, innerHeight: height } = window;
    return width / height;
}

// Hook to get the window dimensions
export default function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [aspectRatio, setAspectRatio] = useState(getAspectRatio());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
            setAspectRatio(getAspectRatio());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions, aspectRatio;
}